import React from 'react';
import { Switch, Route, Redirect } from 'react-router';

import AuthOrApp from './authOrApp'
import Dashboard from '../dashboard/dashboard';
import UsuarioPerfil from '../usuarioPerfil/usuarioPerfil';
import Usuario from '../usuario/usuario';
import Empresa from '../empresa/empresa';
import Fornecedor from '../fornecedor/fornecedor';
import TipoProducao from '../tipoProducao/tipoProducao';
import FaseProducao from '../faseProducao/faseProducao';
import Parceiro from '../parceiro/parceiro';
import Transportadora from '../transportadora/transportadora';
import Motorista from '../motorista/motorista';
import Veiculo from '../veiculo/veiculo';
import MateriaPrima from '../materiaPrima/materiaPrima';
import UnidadeMedida from '../unidadeMedida/unidadeMedida';
import Racao from '../racao/racao';
import Equipamento from '../equipamento/equipamento';
import Solicitacao from '../solicitacao/solicitacao';
import ProducaoProgramacao from '../producao/producaoProgramacao';
import Producao from '../producao/producao';
import Carga from '../carga/carga';
import ProducaoCarga from '../producaoCarga/producaoCarga';

export default props => (
	<div id='id-content-wrapper' className='content-wrapper' style={{ paddingBottom: 0 }} >
		<Switch>
			<Route exact path='/' component={Dashboard} />
			<Route path='/usuarioPerfil' component={UsuarioPerfil} />
			<Route path='/usuario' component={Usuario} />
			<Route path='/empresa' component={Empresa} />
			<Route path='/fornecedor' component={Fornecedor} />
			<Route path='/tipoProducao' component={TipoProducao} />
			<Route path='/faseProducao' component={FaseProducao} />
			<Route path='/parceiro' component={Parceiro} />
			<Route path='/transportadora' component={Transportadora} />
			<Route path='/motorista' component={Motorista} />
			<Route path='/veiculo' component={Veiculo} />
			<Route path='/materiaPrima' component={MateriaPrima} />
			<Route path='/unidadeMedida' component={UnidadeMedida} />
			<Route path='/racao' component={Racao} />
			<Route path='/equipamento' component={Equipamento} />
			<Route path='/solicitacao' component={Solicitacao} />
			<Route path='/producao' component={Producao} />
			<Route path='/producaoProgramacao' component={ProducaoProgramacao} />
			<Route path='/carga' component={Carga} />
			<Route path='/producaoCarga' component={ProducaoCarga} />
			<Redirect from='*' to='/' />
		</Switch>
	</div>
);
